import React from 'react';
import styled from 'styled-components';
import { inputStyle } from './Input';
import { CurrencyInput, Currencies, Locales } from 'input-currency-react';

const StyledInput = styled(CurrencyInput)`
  ${inputStyle}
  height: 33px;
  text-align: left !important;
`;

export const CurrencyNumeric = ({ value, onChange, error, variant, ...rest }) => {
  const handleOnChange = (inputElement, maskedValue, value) => {
    onChange(value);
  };

  return (
    <StyledInput
      value={value}
      options={{
        precision: 2,
        style: 'currency',
        locale: Locales['Portuguese (Brazil)'],
        i18nCurrency: Currencies['Brazilian Real']
      }}
      autoFocus={true}
      onChangeEvent={handleOnChange}
      {...rest}
    />
  );
};
